export default __webpack_public_path__ + "static/media/line.55b6f5b9.png";